export const PageHeader = ({ eyebrow, title, lede, align = "left" }) => {
  return (
    <section className="relative pt-40 pb-16 lg:pt-48 lg:pb-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
          {eyebrow && <div className="eyebrow mb-6 fade-in-up">{eyebrow}</div>}
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-white fade-in-up delay-1">
            {title}
          </h1>
          {lede && (
            <p className="mt-8 text-muted text-base sm:text-lg leading-relaxed max-w-2xl fade-in-up delay-2">
              {lede}
            </p>
          )}
        </div>
      </div>
      <div className="bw-hairline mt-16" />
    </section>
  );
};

export default PageHeader;
